import * as action from './actions/creators';
import * as api from './treatment-summary-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

export const loadTreatmentSummaryItems = (patientId) => (dispatch) =>
  api.getPatientTreatmentSummaryItems(patientId).then(
    (response) => dispatch(action.treatmentSummaryItemsLoaded(response.data)),
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage());
      dispatch(action.treatmentSummaryItemsFailed(error.message));
    }
  );

export const unseenCountTreatmentSummaryItems = (patientId) => (dispatch) =>
  api.getCountUnseenTreatmentSummaryItems(patientId).then(
    (response) => dispatch(action.unseenTreatmentSummaryCountLoaded(response.data)),
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(action.unseenTreatmentSummaryCountFailed(error.message));
    }
  );
